export default __webpack_public_path__ + "7e14f0b40b9a5432ce6988068a1a2f8b.svg";